import Button from '../../../common/Button/Button';
import styles from './TeamMemberTrainings.module.scss';
import SplitButton, { SplitButtonProps } from '../../../common/SplitButton/SplitButton';
import { TeamMemberTrainingsSplitButtonOptions } from './TeamMemberTrainings.types';
import { useTeamMemberReport } from '../../../../lib/api/reportsApi';
import useFeature from '../../../../lib/hooks/useFeature';
import { ReportConfig } from '../../../../lib/types/aemDataModels';
import { useViewContext } from '../../../../lib/context/ViewContext';
import Loader from '../../../common/Loader/Loader';
import { classes } from '../../../../lib/utils/cssUtils';
import useDownloadReport from '../../../../lib/hooks/useDownloadReport';
import { FeatureToggleCodename } from '../../../../lib/types/enums';

type TeamMemberTrainingsActionsProps = {
  reportConfig?: ReportConfig;
  buttonLabel: string;
  reportButtonLabel?: string;
  setShowAssignModal: (value: boolean) => void;
};

const TeamMemberTrainingsActions = ({
  reportButtonLabel,
  reportConfig,
  buttonLabel,
  setShowAssignModal,
}: TeamMemberTrainingsActionsProps) => {
  const assignmentEnabled = useFeature(FeatureToggleCodename.memberAssignTraining);
  const { page } = useViewContext();
  const downloadReport = useTeamMemberReport();
  const { wrappedDownloadReport, downloadingReport } = useDownloadReport({
    reportConfig,
    action: downloadReport,
  });

  const splitButtonOptions: SplitButtonProps<TeamMemberTrainingsSplitButtonOptions>['options'] = [
    ...(assignmentEnabled ? [{ label: buttonLabel, value: 'assignment' as const }] : []),
    ...(reportConfig ? [{ label: reportButtonLabel || '', value: 'report' as const }] : []),
  ];

  const splitButtonActionsMap: Record<TeamMemberTrainingsSplitButtonOptions, () => void> = {
    assignment: () => setShowAssignModal(true),
    report: async () => wrappedDownloadReport(page?.memberId || ''),
  };

  if (splitButtonOptions.length === 0) {
    return null;
  }

  if (splitButtonOptions.length === 1) {
    return (
      <Button className={styles.actionButton} onClick={splitButtonActionsMap[splitButtonOptions[0].value]}>
        {splitButtonOptions[0].label}
      </Button>
    );
  }

  return (
    <>
      {downloadingReport && <Loader containerProps={{ className: styles.actionLoader }} />}
      <SplitButton
        className={classes(styles.actionButton, { [styles.hideButton]: downloadingReport })}
        options={splitButtonOptions}
        onOptionSelect={action => splitButtonActionsMap[action]()}
      />
    </>
  );
};

export default TeamMemberTrainingsActions;
